import { render, staticRenderFns } from "./LuxuryPropertiesForSale.vue?vue&type=template&id=ebf75092&scoped=true&"
import script from "./LuxuryPropertiesForSale.vue?vue&type=script&lang=ts&"
export * from "./LuxuryPropertiesForSale.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebf75092",
  null
  
)

export default component.exports